import React from 'react';
import PropTypes from 'prop-types';
import styles from './uploadInteraction.scss';

class RemoveButton extends React.PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        services: PropTypes.object.isRequired,
        showConfirmation: PropTypes.func.isRequired,
    };

    render() {
        const { t } = this.props.services.translationService;

        return (
            <button
                className={styles.button}
                disabled={this.props.disabled}
                onClick={this.props.showConfirmation}
            >
                <i className="fa fa-times" aria-hidden="true" />{t('interactions.upload.btnRemove')}
            </button>
        );
    }
}

export default RemoveButton;
